import * as i0 from '@angular/core';
import { Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import { SizeToIconSizePipe, transformIconSizeToSize } from '@engineering11/ui-lib/e11-ui-config';
import { NgClass, NgIf, NgStyle } from '@angular/common';

class E11DividerComponent {
    constructor() {
        /**
         * The text to be displayed.
         */
        this.text = '';
        /**
         * @deprecated unused
         * The style of the divider.
         */
        this.style = 'solid';
        /**
         * The style of the text.
         */
        this.textStyle = '';
        /**
         * The background color of the text.
         * Default is 'e11-bg-skin-app-bg'.
         */
        this.textBg = 'e11-bg-skin-app-bg'; // just white or app-bg, anything else would be very edge case
        /**
         * The color of the divider.
         * Default is 'e11-border-skin-grey'.
         */
        this.color = 'e11-border-skin-grey';
        /**
         * The height of the divider.
         * Can be 'sm', 'md', or 'lg'.
         */
        this.height = 'sm'; // md, lg
        /**
         * The width of the divider as a percentage.
         * Default is 100.
         */
        this.width = 100;
        /**
         * @deprecated unused
         * The background color of the divider.
         */
        this.bgcolor = '';
        /**
         * @deprecated unused
         * Whether the divider is part of a panel.
         */
        this.panel = false;
        /**
         * The margin around the divider in rem units.
         * Default is 2.
         */
        this.margin = 2;
        /**
         * Use `Size` values (e.g. sm, md...) to set the icon size.
         * `IconSize` still works but is deprecated and will be removed in the future.
         */
        this.iconSize = 'md';
        /**
         * The icon to be displayed.
         */
        this.icon = '';
        /**
         * The color of the icon.
         */
        this.iconColor = '';
        /**
         * Whether the icon has a circle around it.
         */
        this.hasCircle = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: E11DividerComponent, isStandalone: true, selector: "e11-divider", inputs: { text: "text", style: "style", textStyle: "textStyle", textBg: "textBg", color: "color", height: "height", width: "width", bgcolor: "bgcolor", panel: "panel", margin: "margin", iconSize: ["iconSize", "iconSize", (value) => transformIconSizeToSize(value)], icon: "icon", iconColor: "iconColor", hasCircle: "hasCircle" }, ngImport: i0, template: `
    <div class="e11-divider e11-relative" [ngStyle]="{ 'margin-top': margin + 'rem', 'margin-bottom': margin + 'rem' }">
      <div class="e11-absolute e11-inset-0 e11-flex e11-items-center" aria-hidden="true">
        <div
          class="e11-mx-auto {{ color }}"
          [ngClass]="{ 'e11-border-t': height === 'sm', 'e11-border-2': height === 'md', 'e11-border-4': height === 'lg' }"
          [ngStyle]="{ width: width + '%', 'margin-top': margin + 'rem', 'margin-bottom': margin + 'rem' }"
        ></div>
      </div>
      <div class="e11-divider-content e11-relative e11-flex e11-justify-center">
        <div
          class="e11-rounded-full e11-border-2 e11-p-2 e11-flex e11-justify-center e11-items-center"
          [ngClass]="hasCircle ? textBg + ' e11-border-skin-' + iconColor : 'e11-border-transparent'"
        >
          <div class="{{ textBg }} e11-px-2" *ngIf="icon">
            <div class="icon e11-flex">
              <span class="material-icons {{ iconSize | sizeToIconSize }} {{ 'e11-text-skin-' + iconColor }}"> {{ icon }} </span>
            </div>
          </div>

          <span class="e11-flex e11-items-center e11-text-xs {{ textStyle }} {{ textBg }}" [ngClass]="{ 'e11-px-4': text }">
            {{ text }}
          </span>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [".e11-divider .e11-divider-content .pill{height:2rem;border-radius:.5rem;border-width:1px;--tw-border-opacity: 1;border-color:rgba(var(--color-grey),var(--tw-border-opacity, 1));--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1));padding-left:1.5rem;padding-right:1.5rem}.e11-divider .e11-divider-content .box{height:2rem;border-radius:.125rem;border-width:1px;--tw-border-opacity: 1;border-color:rgba(var(--color-grey),var(--tw-border-opacity, 1));--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1));padding-left:1.5rem;padding-right:1.5rem}\n"], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: SizeToIconSizePipe, name: "sizeToIconSize" }, { kind: "directive", type: NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DividerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-divider', standalone: true, imports: [NgClass, NgIf, SizeToIconSizePipe, NgStyle], template: `
    <div class="e11-divider e11-relative" [ngStyle]="{ 'margin-top': margin + 'rem', 'margin-bottom': margin + 'rem' }">
      <div class="e11-absolute e11-inset-0 e11-flex e11-items-center" aria-hidden="true">
        <div
          class="e11-mx-auto {{ color }}"
          [ngClass]="{ 'e11-border-t': height === 'sm', 'e11-border-2': height === 'md', 'e11-border-4': height === 'lg' }"
          [ngStyle]="{ width: width + '%', 'margin-top': margin + 'rem', 'margin-bottom': margin + 'rem' }"
        ></div>
      </div>
      <div class="e11-divider-content e11-relative e11-flex e11-justify-center">
        <div
          class="e11-rounded-full e11-border-2 e11-p-2 e11-flex e11-justify-center e11-items-center"
          [ngClass]="hasCircle ? textBg + ' e11-border-skin-' + iconColor : 'e11-border-transparent'"
        >
          <div class="{{ textBg }} e11-px-2" *ngIf="icon">
            <div class="icon e11-flex">
              <span class="material-icons {{ iconSize | sizeToIconSize }} {{ 'e11-text-skin-' + iconColor }}"> {{ icon }} </span>
            </div>
          </div>

          <span class="e11-flex e11-items-center e11-text-xs {{ textStyle }} {{ textBg }}" [ngClass]="{ 'e11-px-4': text }">
            {{ text }}
          </span>
        </div>
      </div>
    </div>
  `, encapsulation: ViewEncapsulation.None, styles: [".e11-divider .e11-divider-content .pill{height:2rem;border-radius:.5rem;border-width:1px;--tw-border-opacity: 1;border-color:rgba(var(--color-grey),var(--tw-border-opacity, 1));--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1));padding-left:1.5rem;padding-right:1.5rem}.e11-divider .e11-divider-content .box{height:2rem;border-radius:.125rem;border-width:1px;--tw-border-opacity: 1;border-color:rgba(var(--color-grey),var(--tw-border-opacity, 1));--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1));padding-left:1.5rem;padding-right:1.5rem}\n"] }]
        }], propDecorators: { text: [{
                type: Input
            }], style: [{
                type: Input
            }], textStyle: [{
                type: Input
            }], textBg: [{
                type: Input
            }], color: [{
                type: Input
            }], height: [{
                type: Input
            }], width: [{
                type: Input
            }], bgcolor: [{
                type: Input
            }], panel: [{
                type: Input
            }], margin: [{
                type: Input
            }], iconSize: [{
                type: Input,
                args: [{ transform: (value) => transformIconSizeToSize(value) }]
            }], icon: [{
                type: Input
            }], iconColor: [{
                type: Input
            }], hasCircle: [{
                type: Input
            }] } });

class E11DividerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DividerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11DividerModule, imports: [E11DividerComponent], exports: [E11DividerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DividerModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DividerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [E11DividerComponent],
                    exports: [E11DividerComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11DividerComponent, E11DividerModule };
